import { Button, Box, TextField, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Delete_Selected_Payment_For_Commission_Data_Action,
  Get_All_Pays_For_Commission_Data_Action,
  UpdatePaymentAction,
} from '../Redux/Actions/Commission_pay_Action';
import moment from 'moment';
import { Notify } from '../Utility/Notify';

export const PaymentsTable = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع ال

  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setloading] = useState(true);

  const getAllData = async () => {
    setloading(true);
    await dispatch(Get_All_Pays_For_Commission_Data_Action(id));
    setloading(false);
  };

  useEffect(() => {
    getAllData();
  }, []);

  const resALLpayments = useSelector(
    (state) => state.AllSchedual_Commission_Dates.Get_All_Commission_Payments,
  );
  let AllPaymentsData_Array = Array.isArray(resALLpayments?.data) ? resALLpayments.data : [];

  // ========================== UPDATE Modal ========================
  const [money, setmoney] = useState('');
  const [loadingpay, setloadingpay] = useState(true);
  const [showpaymodal, setshowpaymodal] = useState(false);
  const [selectedpayupdateId, setselectedpayupdateId] = useState(null);

  const handleClosepaymodal = () => setshowpaymodal(false);

  const handleShowpaymodal = (id, oldValue) => {
    setselectedpayupdateId(id);
    setmoney(oldValue);
    setshowpaymodal(true);
  };

  const submitupdatepay = async () => {
    setloadingpay(true);
    await dispatch(UpdatePaymentAction(selectedpayupdateId, { moneyispaid: money }));
    setloadingpay(false);
    setshowpaymodal(false);
    Notify('success', 'Updated Done', 'success');
    getAllData();
  };

  // ========================== DELETE Modal ========================
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const handleShowDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedDeleteId(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    await dispatch(Delete_Selected_Payment_For_Commission_Data_Action(selectedDeleteId));
    Notify('success', 'Payment Deleted Successfully', 'success');
    setShowDeleteModal(false);
    getAllData();
  };

  return (
    <Container className="startpage py-4 fade-in">
      {/* 🧾 Pay Modal */}
      <Modal show={showpaymodal} onHide={handleClosepaymodal}>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>Update Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <TextField
            value={money}
            onChange={(e) => setmoney(e.target.value)}
            type="number"
            label="Money Paid"
            variant="outlined"
            className="w-100 my-2"
          />
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={handleClosepaymodal}>
            Close
          </Button>
          <Button variant="primary" onClick={submitupdatepay}>
            Confirm Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 🗑️ Delete Modal */}
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          Are you sure you want to delete this payment?
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Confirm Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <h3 style={{ color: '#0F7687', fontWeight: 'bold' }}>🧾 Payments Table</h3>

      <Box
        sx={{
          maxHeight: '700px',
          overflowY: 'auto',
          mt: 3,
          border: '1px solid #ddd',
          borderRadius: 2,
          boxShadow: 2,
        }}
        style={{
          color: mode === 'dark' ? '#90caf9' : '#0F7687',
          backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
        }}
      >
        <Table
          striped
          bordered
          hover
          responsive
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <thead
            style={{
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            <tr
              style={{
                color: mode === 'dark' ? '#90caf9' : '#0F7687',
                backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
              }}
            >
              <th>Lead Name</th>
              <th>Developer</th>
              <th>Project</th>
              <th>Payment Amount</th>
              <th>Paid</th>
              <th>Remaining</th>
              <th>Date Of Payment</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              let totalCommission = AllPaymentsData_Array[0]?.Commission?.commissionValue || 0;
              let runningBalance = totalCommission;
              let totalPaid = 0;

              const rows = AllPaymentsData_Array.map((payment, index) => {
                const paidThisTime = payment?.moneyispaid || 0;
                totalPaid += paidThisTime;

                const remaining = runningBalance - paidThisTime;
                const displayPaid = paidThisTime?.toLocaleString();
                const displayRemaining = remaining?.toLocaleString();

                runningBalance = remaining;

                return (
                  <tr key={index}>
                    <td>{payment?.Lead?.name || 'N/A'}</td>
                    <td>{payment?.project?.developer?.name || 'N/A'}</td>
                    <td>{payment?.project?.name || 'N/A'}</td>
                    <td>{payment?.MoneyOfPayment?.toLocaleString()} AED</td>
                    <td>{displayPaid} AED</td>
                    <td style={{ color: remaining > 0 ? 'red' : 'green' }}>
                      {displayRemaining} AED
                    </td>
                    <td>{moment(payment?.createdAt).format('DD/MM/YYYY')}</td>
                    <td>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<EditIcon />}
                        onClick={() => handleShowpaymodal(payment._id, paidThisTime)}
                      >
                        Update
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        startIcon={<DeleteIcon />}
                        sx={{ ml: 1 }}
                        onClick={() => handleShowDeleteModal(payment._id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                );
              });

              rows.push(
                <tr key="totals" style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                  <td colSpan={4} style={{ textAlign: 'right' }}>
                    Totals:
                  </td>
                  <td style={{ color: '#2196f3' }}>{totalPaid.toLocaleString()} AED</td>
                  <td style={{ color: '#f44336' }}>
                    {(totalCommission - totalPaid).toLocaleString()} AED
                  </td>
                  <td colSpan={2}></td>
                </tr>,
              );

              return rows;
            })()}
          </tbody>
        </Table>
      </Box>
    </Container>
  );
};
